// Gama comercial del producto del catálogo en el idioma de la tienda. Puro.

/** Lo que se pinta cuando el catálogo no trae gama. */
const NO_TIER = '—';

/** Gama comercial del producto (`ProductTierEnum` del type-kit), en el idioma de la tienda. */
const PRODUCT_TIER_LABEL: Record<string, string> = {
    LOW: 'Gama de entrada',
    MID: 'Gama media',
    HIGH: 'Gama alta',
    PREMIUM: 'Gama premium',
};

/** La gama en español. Una gama nueva se muestra cruda, no se traduce a la que no es. */
export function productTierLabel(tier: string): string {
    const trimmed = tier.trim();
    if (!trimmed) return NO_TIER;
    return PRODUCT_TIER_LABEL[trimmed] ?? trimmed;
}
